import React from "react";
import PropTypes from "prop-types";

import { Heading, Subheading, SecondaryInfo, StatsContainer } from "./styles";

const Stats = ({ heading, subheading, secondaryInfo }) => (
    <StatsContainer>
        <Subheading>{subheading}</Subheading>
        <Heading>{heading}</Heading>
        <SecondaryInfo>
            {secondaryInfo.map((info, index) => (
                <li key={index}>{info}</li>
            ))}
        </SecondaryInfo>
    </StatsContainer>
);

Stats.propTypes = {
    heading: PropTypes.string.isRequired,
    subheading: PropTypes.string.isRequired,
    secondaryInfo: PropTypes.arrayOf(PropTypes.element).isRequired
};

export default Stats;
